import { Component, computed, forwardRef, inject, input } from '@angular/core';
import { TranslatePipe, TranslateService } from '@ngx-translate/core';
import {
  OnyxButtonComponent,
  OnyxIconComponent,
  OnyxMessageComponent,
  OnyxTooltipDirective,
} from '@onyx/angular';
import type { Subject } from 'rxjs';
import { DocumentsFormListComponent } from '../../../../../common/components/forms/documents-form/documents-form-list/documents-form-list.component';
import { OrderHelper } from '../../../common/helpers/order.helper';
import type { Order, OrderDocument } from '../../../common/interfaces/order';

@Component({
  selector: 'app-order-modal-documents',
  imports: [
    OnyxIconComponent,
    OnyxButtonComponent,
    TranslatePipe,
    OnyxIconComponent,
    forwardRef(() => DocumentsFormListComponent),
    OnyxMessageComponent,
    OnyxTooltipDirective,
  ],
  templateUrl: './order-modal-documents.component.html',
  styleUrl: './order-modal-documents.component.scss',
  host: {
    '[style.gap.px]': `showRequirements() ? 16 : 12`,
  },
})
export class OrderModalDocumentsComponent {
  private readonly orderHelper = inject(OrderHelper);
  private readonly translateService = inject(TranslateService);

  public readonly order = input.required<Order>();
  public readonly close$ = input.required<Subject<void>>();
  public readonly showRequirements = input(false);
  public readonly hasRequiredDocuments = input(false);

  protected readonly I18N = 'orders.orderModal';

  protected documents = computed(() => {
    const invoice = this.order().payment?.invoice;
    if (!invoice?.scan) return this.order().documents;

    const invoiceDocument: OrderDocument = {
      name: `${this.translateService.instant('labels.invoice')} - ${invoice.number}`,
      note: null,
      attachments: [invoice.scan],
    };

    return [invoiceDocument, ...this.order().documents];
  });
  protected editLock = computed(() => OrderHelper.getEditLock(this.order()));

  protected addDocument(): void {
    this.orderHelper.edit(this.order().uuid, {
      options: { close$: this.close$() },
    });
  }
}
